import React, { lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { REQUEST_FOR_CALLBACK_PATH } from "./paths";

const RequestForCallback = lazy(() => import("pages/Forms/RequestForCallback"));
const AutoThankYou = lazy(() => import("pages/ThankYou"));

const RequestForCallbackRoutes = () => {
  return (
    <Switch>
      <Route
        path="/request-for-callback/thankyou/:id"
        component={AutoThankYou}
      />
      <Route
        path={`${REQUEST_FOR_CALLBACK_PATH}:id`}
        component={RequestForCallback}
      />

      <Route path="*" component={() => <Redirect to="/" />} />
    </Switch>
  );
};

export default RequestForCallbackRoutes;
